import { mapMutationsFromTypes } from 'schepotin-vuex-helpers';
import * as types from './mutation-types';
import * as constants from '../../../utils/constants';

export default {
    /**
     * Generates {@link https://vuex.vuejs.org/en/mutations.html | mutations} from
     * {@link https://vuex.vuejs.org/en/mutations.html#using-constants-for-mutation-types | mutation types}
     *
     * Documentation
     * {@link https://www.npmjs.com/package/schepotin-vuex-helpers#mapmutationsfromtypes | mapMutationsFromTypes}
     */
    ...mapMutationsFromTypes({
        types,
        excludes: [
            types.LOGIN,
            types.LOGOUT,
            types.CURRENT_LANG,
            types.CURRENT_DIRECTION,
            types.DEFAULT_LANGUAGE,
            types.DEFAULT_DIRECTION,
            types.IMAGE,
        ],
    }),
    [types.LOGIN](state, payload) {
        window.setAppStorage('token', payload.token);
        window.axios.defaults.headers.common.Authorization = `Bearer ${payload.token}`;

        state.token = payload.token;
        state.logged = true;
    },
    [types.LOGOUT](state) {
        window.removeAppStorage('token');
        window.axios.defaults.headers.common.Authorization = '';

        state.token = null;
        state.logged = false;
    },
    [types.CURRENT_LANG](state, payload) {
        window.authCurrentLang = payload;

        if (window.mainApp.$route.name !== 'workspace' || window.mainApp.$store.getters['auth/logged']) {
            window.setAppStorage('locale', payload);
        }

        state.currentLang = payload;
    },
    [types.CURRENT_DIRECTION](state, payload) {
        // Fix xamarin app
        window.mainApp.$router.push({
            query: {
                lang: window.authCurrentLang,
                direction: payload,
            },
        });

        if (window.mainApp.$route.name !== 'workspace' || window.mainApp.$store.getters['auth/logged']) {
            window.setAppStorage('direction', payload);
        }

        state.currentDirection = payload;
    },
    [types.DEFAULT_LANGUAGE](state, payload) {;
        window.authCurrentLang = payload;

        if (window.mainApp.$route.name !== 'workspace' || window.mainApp.$store.getters['auth/logged']) {
            window.setAppStorage('locale', payload);
        }

        state.currentLang = payload;
    },
    [types.DEFAULT_DIRECTION](state, payload) {
        let needUpdate = false;

        if (state.currentDirection !== payload) {
            needUpdate = true;
        }

        if (window.mainApp.$route.name !== 'workspace' || window.mainApp.$store.getters['auth/logged']) {
            window.setAppStorage('direction', payload);
        }

        state.currentDirection = payload;

        if (needUpdate) {
            window.location.reload();
        }
    },
    [types.IMAGE](state, payload) {
        if (payload === null) {
            state.image = './static/images/Profile_4.png';
        } else if (payload.indexOf('http') === 0) {
            state.image = payload;
        } else if (payload.indexOf('/static/images') < 0) {
            state.image = `${window.location.origin}:${constants.API_PORT}${payload}`;
        } else {
            state.image = payload;
        }
    },
    [types.LESSON_DASHBOARD](state, payload) {
        state.dashboard.coursesActive = payload.courses_active;
        state.dashboard.coursesCompleted = payload.courses_completed;
        state.dashboard.lessonsCompleted = payload.lessons_completed;
        state.dashboard.skillsAcquired = payload.skills_acquired;
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js